<div class="inventory-container">
  <!-- Section header: title, search and every list action on one row. Action
       order matches Orders — filter, clear, download, columns, then the page's
       own actions, primary last (WB-7275). -->
  <ui-page-header
    class="products-header"
    [title]="'inventory.inventory' | translate"
    lucideIcon="Package"
    [searchable]="true"
    searchTestId="products-search"
    [searchControl]="searchInput"
    [searchPlaceholder]="'inventory.search' | translate"
    (searchInput)="search($event)"
  >
    <!-- Filter, with its clear badge (see ui-filter-action). -->
    <ui-filter-action
      [active]="hasModuleFilters()"
      (filter)="setFilter()"
      (clear)="clearFilter()"
    ></ui-filter-action>

    <!-- Download -->
    <button
      type="button"
      class="ui-header-action"
      [attr.aria-label]="'inventory.download' | translate"
      [matTooltip]="'inventory.download' | translate"
      matTooltipPosition="below"
      (click)="exportProducts()"
    >
      <img src="assets/icones/download_icon.svg" alt="" />
    </button>

    <!-- Configure columns -->
    <ui-table-column-settings
      triggerIcon="sliders-horizontal"
      [columns]="pickerColumns"
      (columnsChange)="onColumnsChange($event)"
    ></ui-table-column-settings>

    <!-- Bulk actions for the current selection live in the floating
         ui-bulk-actions-bar at the bottom of the table, not here. -->

    <!-- New Product -->
    <ui-button
      *appHasPermission="{ module: 'product', action: 'create' }"
      type="primary"
      icon="plus-cc"
      [label]="'inventory.add_product' | translate"
      (click)="addProduct()"
    ></ui-button>
  </ui-page-header>
  <div class="inventory-content" [class.inventory-content--with-bulk-bar]="selection.hasSelection">
    <div class="table-wrapper">
      <table class="inventory-table">
        <thead>
          <tr class="row header" [style.grid-template-columns]="gridTemplateColumns">
            <th class="select-cell" [style.order]="0">
              <ui-checkbox
                [checked]="selection.isAllSelected"
                [indeterminate]="selection.isPartialSelected"
                [ariaLabel]="'common.select_all' | translate"
                (changed)="selection.toggleAll($event.checked)"
              ></ui-checkbox>
              <ng-container *ngIf="isColumnVisible('image')">
                {{"inventory.img"|translate}}
              </ng-container>
            </th>
            <th class="name-col" [style.order]="columnOrder('name')">
              <div class="header-title-with-sort">
                <span>{{ "inventory.product" | translate }}</span>
                <div class="sort-actions">
                  <span class="arrow-up" [class.active]="activeSortMode == 'asc' && activeSortBy == 'name'" (click)="sortBy('name', 'asc')"></span>
                  <span class="arrow-down" [class.active]="activeSortMode == 'desc' && activeSortBy == 'name'" (click)="sortBy('name', 'desc')"></span>
                </div>
              </div>
            </th>
            <th *ngIf="isColumnVisible('erp_id')" [style.order]="columnOrder('erp_id')">{{ "inventory.erp_id" | translate }}</th>
            <th *ngIf="isColumnVisible('sku')" [style.order]="columnOrder('sku')">
              <div class="header-title-with-sort">
                <span>{{ "inventory.sku" | translate }}</span>
                <div class="sort-actions">
                  <span class="arrow-up" [class.active]="activeSortBy == 'sku' && activeSortMode == 'asc'" (click)="sortBy('sku', 'asc')"></span>
                  <span class="arrow-down" [class.active]="activeSortBy == 'sku' && activeSortMode == 'desc'" (click)="sortBy('sku', 'desc')"></span>
                </div>
              </div>
            </th>
            <th *ngIf="isColumnVisible('ean')" [style.order]="columnOrder('ean')">{{"inventory.ean"|translate}}</th>
            <th *ngIf="isColumnVisible('brand')" [style.order]="columnOrder('brand')">{{"brands.brands"|translate}}</th>
            <th *ngIf="isColumnVisible('categories')" [style.order]="columnOrder('categories')">{{"Categories.categories"|translate}}</th>
            <th *ngIf="isColumnVisible('variants')" [style.order]="columnOrder('variants')">{{"Catalogs.variant"|translate}}</th>
            <th *ngIf="isColumnVisible('stock')" [style.order]="columnOrder('stock')">
              <div class="header-title-with-sort">
                <span>{{"inventory.stock"|translate}}</span>
                <div class="sort-actions">
                  <span class="arrow-up" [class.active]="activeSortBy == 'stock_quantity' && activeSortMode == 'asc'" (click)="sortBy('stock_quantity', 'asc')"></span>
                  <span class="arrow-down" [class.active]="activeSortBy == 'stock_quantity' && activeSortMode == 'desc'" (click)="sortBy('stock_quantity', 'desc')"></span>
                </div>
              </div>
            </th>
            <th *ngIf="isColumnVisible('catalogs')" [style.order]="columnOrder('catalogs')">{{"Catalogs.catalogs"|translate}}</th>
            <th *ngIf="isColumnVisible('sales_price')" [style.order]="columnOrder('sales_price')">{{"Catalogs.retail_price"|translate}}</th>
            <th *ngIf="isColumnVisible('performance')" [style.order]="columnOrder('performance')">{{ "inventory.performance"|translate }}</th>
            <th *ngIf="isColumnVisible('last_order')" [style.order]="columnOrder('last_order')">{{ "agent.listing.last_order" | translate }}</th>
            <th *ngIf="isColumnVisible('status')" [style.order]="columnOrder('status')">{{ "common.status" | translate }}</th>
          </tr>
        </thead>
        <tbody class="inventory-viewport" *ngIf="(products$ | async)!.length > 0">
            <ng-container *ngFor="let product of products$ | async; let i = index">
              <tr class="row body" [style.grid-template-columns]="gridTemplateColumns">
                <td [class]="(product.attributes && product.attributes.length > 0) ? 'select-cell cursor' : 'select-cell'" (click)="toggleVariants(product.id!)" class="first_td" [style.order]="0">
                  <ui-checkbox
                    [checked]="selection.isSelected(product.id!)"
                    [ariaLabel]="'common.select' | translate"
                    (changed)="selection.toggleOne(product.id!, $event.checked, $event)"
                  ></ui-checkbox>
                  <div style="display: flex; gap: 10px; align-items: start;" *ngIf="isColumnVisible('image')">
                    <img
                      class="listing_image"
                      [class]="!product.image ? 'no-image' : ''"
                      [src]="failedImages.has(product.image!) ? 'assets/icones/default-image-product.svg' : getImage(product.image!)"
                      alt=""
                      (error)="onImageError(product.image!)"
                    >
                  </div>
                </td>
                <td (click)="editProduct(product)" class="name-col cursor" [style.order]="columnOrder('name')">
                  <ui-copyable [value]="product.name" [label]="'common.name' | translate">
                    <span title="{{product.name}}" class="bold_span_inventory name-clamp">{{ product.name }}</span>
                  </ui-copyable>
                </td>
                <td *ngIf="isColumnVisible('erp_id')" (click)="editProduct(product)" class="cursor" [style.order]="columnOrder('erp_id')">
                  <ui-copyable [value]="product.erp_id" [label]="'inventory.erp_id' | translate">
                    <span title="{{product.erp_id}}" class="light_span">{{product.erp_id || '__'}}</span>
                  </ui-copyable>
                </td>
                <td *ngIf="isColumnVisible('sku')" (click)="editProduct(product)" class="cursor" [style.order]="columnOrder('sku')">
                  <ui-copyable [value]="product.sku" [label]="'inventory.sku' | translate">
                    <span title="{{product.sku}}" class="light_span">{{product.sku || '__'}}</span>
                  </ui-copyable>
                </td>
                <td *ngIf="isColumnVisible('ean')" (click)="editProduct(product)" class="cursor" [style.order]="columnOrder('ean')">
                  <span title="{{product.barcode}}" class="light_span">{{product.barcode || '__'}}</span>
                </td>
                <td *ngIf="isColumnVisible('brand')" (click)="editProduct(product)" class="cursor" [style.order]="columnOrder('brand')">
                  <span>{{product.brand?.name ?? '__'}}</span>
                </td>
                <td *ngIf="isColumnVisible('categories')" (click)="editProduct(product)" class="cursor" [style.order]="columnOrder('categories')">
                  <div class="tags-container" *ngIf="product.categories && product.categories.length > 0 else noCategories">
                    <span class="item_tag">
                      {{product.categories[0].name}}
                    </span>
                    <span *ngIf="product.categories.length > 1" class="item_tag">
                      +{{product.categories.length - 1}}
                    </span>
                  </div>
                  <ng-template #noCategories>
                    __
                  </ng-template>
                </td>
                <td *ngIf="isColumnVisible('variants')" class="td_actions" style="display: flex; flex-direction: row; align-items: center; gap: 18px;" [style.order]="columnOrder('variants')">
                  <img *ngIf="product.variants && product.variants.length > 0" (click)="toggleVariants(product.id!)" [class]="expandedIndex === product.id ? 'arrow_down arrow_up' : 'arrow_down'" src="assets/icones/new-arrow-down.svg" alt=""
                    style="width: 12px; height: 12px;">
                  <span class="bold_span_inventory">
                    {{product.variants ? product.variants.length : 0}}
                  </span>
                </td>
                <td *ngIf="isColumnVisible('stock')" style="display: flex; flex-direction: column; gap: 4px; align-items: start;" (click)="editProduct(product)" class="cursor" [style.order]="columnOrder('stock')">
                  <ng-container *ngIf="product.is_owned === false; else owned">
                    <span class="tag-2">
                      {{'inventory.notOwned' | translate}}
                    </span>
                  </ng-container>
                  <ng-template #owned>
                    <div style="display: flex; align-items: center; gap: 6px;">
                      {{product.stock?.quantity}}
                      <img *ngIf="isStockLow(product)"
                           src="../../../../../assets/icones/warning.svg"
                           alt=""
                           [matTooltip]="'inventory.inventory_level_low' | translate"
                           matTooltipPosition="right">
                    </div>
                  </ng-template>
                </td>
                <td *ngIf="isColumnVisible('catalogs')" (click)="editProduct(product)" style="display: flex; flex-direction: row; gap: 18px;" [style.order]="columnOrder('catalogs')">
                  {{product.nbr_catalogs}}
                  <img src="../../../../../assets/icones/info.svg" alt="">
                </td>
                <td *ngIf="isColumnVisible('sales_price')" [style.order]="columnOrder('sales_price')">{{product.sales_price ? (product.sales_price | number:'1.2-2')+' € '  : '__' }}</td>
                <td *ngIf="isColumnVisible('performance')" (click)="editProduct(product)" class="bold_span_inventory cursor"
                  style="display: flex; flex-direction: row; align-items: center; gap: 14px;"
                  [style.order]="columnOrder('performance')"
                  >{{product.performance ? (product.performance | number:'1.2-2')+' € '  : '__'}}
                  <ng-container *ngIf="product.id === maxPerformanceProduct.id">
                    <span class="tag-success" *ngIf="product.performance && product.performance > 0">
                      {{'inventory.best_saller' | translate}}
                    </span>
                  </ng-container>
                </td>
                <td *ngIf="isColumnVisible('last_order')" [style.order]="columnOrder('last_order')">{{ product.last_order_date ? (product.last_order_date | date : DATE_FORMAT) : "--" }}</td>
                <td *ngIf="isColumnVisible('status')" (click)="editProduct(product)" class="cursor" [style.order]="columnOrder('status')">
                  <ui-status-badge
                    *ngIf="hasStatus(product); else noStatus"
                    size="small"
                    [tone]="statusTone(product)"
                    [label]="statusLabel(product)"
                  ></ui-status-badge>
                  <ng-template #noStatus>__</ng-template>
                </td>
              </tr>
              <tr *ngIf="expandedIndex === product.id" class="variant_table_tr">
                <td *ngIf="product.attributes && product.attributes.length > 0" colspan="99" class="td_variants">
                  <div class="variants_scroll">
                    <table class="variant_table">
                      <tr *ngFor="let variant of product.variants" class="row body_table" [style.grid-template-columns]="gridTemplateColumns">
                        <td class="first_td_variants select-cell" [style.order]="0">
                          <img
                            *ngIf="isColumnVisible('image')"
                            class="listing_image"
                            [class]="!variant.image ? 'no-image' : ''"
                            [src]="failedImages.has(variant.image!) ? 'assets/icones/default-image-product.svg' : getImage(variant.image!)"
                            alt=""
                            (error)="onImageError(variant.image!)"
                          >
                        </td>
                        <td class="name-col" [style.order]="columnOrder('name')">
                          <span class="bold_span_inventory name-clamp" title="{{ variant.values.join(' / ') }}">
                            {{ variant.values.join(' / ') }}
                          </span>
                        </td>
                        <td *ngIf="isColumnVisible('erp_id')" [style.order]="columnOrder('erp_id')">
                          <ui-copyable [value]="variant.erp_id" [label]="'inventory.erp_id' | translate">
                            <span class="light_span">{{ variant.erp_id || '__' }}</span>
                          </ui-copyable>
                        </td>
                        <td *ngIf="isColumnVisible('sku')" [style.order]="columnOrder('sku')">
                          <span class="light_span">{{ variant.sku ?? '__' }}</span>
                        </td>
                        <td *ngIf="isColumnVisible('ean')" [style.order]="columnOrder('ean')">
                          <span class="light_span">{{ variant.barcode ?? '__' }}</span>
                        </td>
                        <td *ngIf="isColumnVisible('brand')" [style.order]="columnOrder('brand')">{{ product.brand?.name ?? '__' }}</td>
                        <td *ngIf="isColumnVisible('categories')" [style.order]="columnOrder('categories')">
                          <div *ngIf="product.categories && product.categories.length > 0 else noCategories">
                            <span *ngFor="let category of product.categories" class="item_tag">
                              {{category.name}}
                            </span>
                          </div>
                          <ng-template #noCategories>
                            __
                          </ng-template>
                        </td>
                        <td *ngIf="isColumnVisible('variants')" [style.order]="columnOrder('variants')"></td>
                        <td *ngIf="isColumnVisible('stock')" style="display: flex; flex-direction: column; gap: 4px; align-items: start;" [class]="(variant.stock?.quantity! < 10 || variant.stock?.quantity! < variant.stock?.reorder_point!) ? 'red' : ''" [style.order]="columnOrder('stock')">
                          <ng-container *ngIf="variant.is_owned === false; else owned">
                            <span class="tag-2">
                              {{'inventory.notOwned' | translate}}
                            </span>
                          </ng-container>
                          <ng-template #owned>
                            <div>
                              {{variant.stock?.quantity}}
                              <img *ngIf="(variant.stock?.quantity! < 10 || variant.stock?.quantity! < variant.stock?.reorder_point! )" src="../../../../../assets/icones/warning.svg" alt="">
                            </div>
                          </ng-template>
                        </td>
                        <td *ngIf="isColumnVisible('catalogs')" [style.order]="columnOrder('catalogs')">
                          {{product.nbr_catalogs}}
                        </td>
                        <td *ngIf="isColumnVisible('sales_price')" [style.order]="columnOrder('sales_price')">{{variant.sales_price ? (variant.sales_price | number:'1.2-2')+' € '  : '__' }}</td>
                        <td *ngIf="isColumnVisible('performance')" [style.order]="columnOrder('performance')">{{ variant.performance ? (variant.performance | number:'1.2-2')+' € '  : '__' }}</td>
                        <td *ngIf="isColumnVisible('last_order')" [style.order]="columnOrder('last_order')">{{ product.last_order_date ? (product.last_order_date | date : DATE_FORMAT) : "--" }}</td>
                        <!-- Variants inherit the parent product's status; shown muted so it never reads as its own state. -->
                        <td *ngIf="isColumnVisible('status')" [style.order]="columnOrder('status')">
                          <ui-status-badge
                            *ngIf="hasStatus(product)"
                            size="small"
                            [muted]="true"
                            [tone]="statusTone(product)"
                            [label]="statusLabel(product)"
                          ></ui-status-badge>
                        </td>
                      </tr>
                    </table>
                  </div>
                </td>
              </tr>
            <tr *ngIf="isExpired(product)" class="variant_table_tr">
              <td colspan="99" class="alert-cell">
                <div class="alert_div alert_div_error">
                  <div class="alert_div_content">
                    <img src="assets/icones/alert_icon.svg" alt="alert-icon">
                    <span class="error-message">
                      {{ 'inventory.product_expired' | translate }}
                    </span>
                  </div>
                </div>
            </td>
          </tr>
            </ng-container>
        </tbody>
      </table>
      <div *ngIf="filter && (products$ | async)!.length === 0  && !(isAppLoading$ | async)" class="no_reseult">
        <ng-container>
          <img src="../../../../../assets/icones/no-inventory.svg" alt="">
          <h3>{{"inventory.no_products_found" | translate}}</h3>
        </ng-container>
        <button mat-icon-button
          *appHasPermission="{ module: 'product', action: 'create' }"
          class="action-btn primary-btn"
          (click)="addProduct()"
        >
          <span class="icon">
            <app-svg-icon svgIcon="plus-cc"></app-svg-icon>
          </span>
          <span> {{ 'inventory.add_product' | translate }} </span>
        </button>
      </div>
    </div>

    <!-- ─────────────────────────────────────────────────────────────────── -->
    <!-- Bulk actions for the current selection. Floats centred at the       -->
    <!-- bottom of the table, above the pagination row.                      -->
    <!-- ─────────────────────────────────────────────────────────────────── -->
    <ui-bulk-actions-bar *ngIf="selection.hasSelection" [count]="selection.count" (cleared)="selection.clear()">
      <button
        *appHasPermission="{ module: 'product', action: 'delete' }"
        class="ui-bulk-action ui-bulk-action--danger"
        (click)="deleteConfirmation()"
      >
        <ui-icon name="Trash2" size="medium"></ui-icon>
        <span>{{ "common.delete" | translate }}</span>
      </button>
    </ui-bulk-actions-bar>
    <!-- ── END BULK ACTIONS BAR ─────────────────────────────────────────── -->

    <app-pagination
      *ngIf="(products$ | async)!.length > 0"
      class="inventory-pagination"
      [pagination]="pagination$ | async"
      (toPageEvent)="toPage($event)"
    ></app-pagination>
  </div>
</div>
